import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { useState } from "react";
import Sign_in_image from "./assets/images/Sign_in_image.jpg";
// import ForgotPasswordScreen from "./components/";
import Home from "../student-build/components/Home/Home";
import Experiment from "./components/Experiments/Experiment";
import Launchtrak from "./components/Launchtrek/Launchtrak";
import NavBar from "./components/Navbar/Navbar";
import ForgotPasswordScreen from "./components/Auth/ForgotPasswordPage/ForgotPasswordScreen";
import { getCookie } from "./Atom";
import LoginScreen from "./components/Auth/LoginPage/LoginScreen";
import Analysis from "./components/Analysis/Analysis";
import LauchtrekDetail from "./components/Launchtrek/LauchtrekDetail";
function Student() {
  const _cookie = getCookie("recoil-persist");
  const user = JSON.parse(_cookie)?.student;
  const [myUser, setmyUser] = useState(user);
  const [loginDone, setLoginDone] = useState(false);
  const [pageTitle, setPageTitle] = useState("");
  function setPageHeader(title) {
    setPageTitle(title);
  }
  function loginOpen() {
    const _cookie = getCookie("recoil-persist");
    const user = JSON.parse(_cookie)["student"];
    setmyUser(user);
    setLoginDone(true);
  }
  return (
    <div className="App teacher-div">
      <Router basename="/">
        {myUser?.token ? (
          <div className="index-bg">
            <img className="class fit-cover" src={Sign_in_image} />
            <div className="login">
              <NavBar
                firstName={myUser?.name}
                email={myUser?.email}
                login={loginDone}
                title={pageTitle}
              />
              <br />
              <br />
              <br />
              <Switch>
                <Route
                  path="/"
                  exact
                  render={(props) => <Experiment page={setPageHeader} />}
                />
                <Route
                  path="/experiments/:id"
                  exact
                  render={(props) => <Analysis page={setPageHeader} />}
                />
                <Route
                  path="/launchtrak"
                  exact
                  render={(props) => <Launchtrak page={setPageHeader} />}
                />
                <Route
                  path="/launchtrak/:id"
                  exact
                  render={(props) => <LauchtrekDetail page={setPageHeader} />}
                />
              </Switch>
            </div>
          </div>
        ) : (
          <Switch>
            <Route
              exact
              path="/"
              // component={LoginScreen}
              render={(props) => <LoginScreen location={loginOpen} />}
            />
            <Route
              exact
              path="/forgot-password"
              component={ForgotPasswordScreen}
            />
          </Switch>
        )}
      </Router>
    </div>
  );
}

export default Student;
